import { apiClientGeral } from '@/plugins/axios'

export default {
  getConferencias() {
    return apiClientGeral().get('/conferencias')
  },

  getConferencia(id) {
    return apiClientGeral().get(`/conferencias/${id}`)
  },

  putConferencia(data, id) {
    return apiClientGeral().put(`/conferencias/${id}`, data)
  },
}
